import { VueModule } from '@Foundation/utilities';
import Countdown from './code/Scripts/components/countdown';

export default VueModule({
  components: {
    Countdown
  }
});
